import { Box } from "@mui/material";
import type { FC, ReactNode } from "react";
import { EyebrowLabel } from "../../../../../components/UIToolkit/molecules/EyebrowLabel";
import { InfoIconWithTooltip } from "../../../../../components/UIToolkit/molecules/InfoIconWithTooltip";
import { CONTROL_HEIGHT } from "../../../../../theme/tokens";

type Props = { label: string; tip: string; testId: string; action?: ReactNode; children: ReactNode };

/** One condition: its label and tip, an optional shortcut on the label's line, and its control. */
export const AutoApproveRuleField: FC<Props> = ({ label, tip, testId, action, children }) => (
	<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, minWidth: 0 }}>
		{/* The label line keeps one height with or without an action, so fields side by side start level. */}
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, minHeight: CONTROL_HEIGHT.MICRO }}>
			<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
				<EyebrowLabel component="span">{label}</EyebrowLabel>
				<InfoIconWithTooltip title={tip} dataTestId={`${testId}-tip`} />
			</Box>
			{action}
		</Box>
		{children}
	</Box>
);
